import styled, { css } from 'styled-components'
import { mediaQueries } from '../../../providers/MediaQueryProvider'

export const Container = styled.div<{
  $variant: 'small' | 'regular' | 'medium' | 'large'
  $flex: number
  $alignCenter?: boolean
  $alignRight?: boolean
}>(
  ({ $variant, $flex, $alignRight, $alignCenter }) => css`
    flex-grow: 1;
    flex: ${$flex};

    & + & {
      ${$variant === 'small' &&
      css`
        margin-top: var(--space-200);
      `};

      ${$variant === 'regular' &&
      css`
        margin-top: var(--space-300);
      `};

      ${$variant === 'medium' &&
      css`
        margin-top: var(--space-400);
      `};

      ${$variant === 'large' &&
      css`
        margin-top: var(--space-800);
      `};

      ${mediaQueries.tablet} {
        margin-top: 0;
        width: auto;
        margin-left: var(--space-400);
      }
    }

    ${$alignRight &&
    css`
      display: flex;
      justify-content: flex-end;
    `};

    ${$alignCenter &&
    css`
      display: flex;
      align-items: center;
    `};
  `,
)

export const Footer = styled.div`
  margin-top: var(--space-50);
`
